import { render, staticRenderFns } from "./ProjectRadioFilter.vue?vue&type=template&id=5735d474"
import script from "./ProjectRadioFilter.vue?vue&type=script&lang=ts"
export * from "./ProjectRadioFilter.vue?vue&type=script&lang=ts"
import style0 from "./ProjectRadioFilter.vue?vue&type=style&index=0&id=5735d474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports